import * as ko from 'knockout';
import { CfbGame } from './models/game';
import { CfbWeek } from './models/week';
import { Enumerable } from '../shared/linq';
import type { IGame } from '../shared/interfaces/IGame';
import type { AppConfig } from '../shared/config';

export function GetSchedule(
  teams: TeamDictionary,
  games: IGameData[],
  cfg: AppConfig,
): WeekDictionary {
  const dict: WeekDictionary = {};
  const maxWeek = Enumerable.From(games).Max((p: IGameData) => p.Week);
  for (let i = 1; i <= maxWeek; i++) {
    dict[i] = [new CfbWeek('Games')] as any;
  }

  const megaTeams = teams['Mega']?.['Mega'];

  for (const game of games) {
    if (cfg.div1 === 'Mega') {
      let home: KnockoutObservable<any>;
      try {
        home = megaTeams[game.Home.TeamID];
      } catch (ex) {
        home = ko.observable(game.Home as any);
      }
      let away: KnockoutObservable<any>;
      try {
        away = megaTeams[game.Away.TeamID];
      } catch (ex) {
        away = ko.observable(game.Away as any);
      }
      const gameObs = ko.observable(
        new CfbGame(
          home, away, game.Week, game.GameTypeID,
          game.GameDateOffset || game.GameDate,
          game.GameKey, game.GameGUID, game.GameScheduleNum,
          game.StartTimeTBD, game.IsConferenceGame,
        ),
      ) as unknown as KnockoutObservable<IGame>;
      dict[game.Week][0].games.push(gameObs);
      home().Schedule().push(gameObs);
      away().Schedule().push(gameObs);
    } else {
      let home: any;
      try {
        home = teams[game.Home.Conference][game.Home.Division][game.Home.TeamID];
      } catch (ex) {
        home = game.Home;
      }
      let away: any;
      try {
        away = teams[game.Away.Conference][game.Away.Division][game.Away.TeamID];
      } catch (ex) {
        away = game.Away;
      }
      dict[game.Week][0].games.push(
        ko.observable(
          new CfbGame(
            home, away, game.Week, game.GameTypeID,
            game.GameDateOffset || game.GameDate,
            game.GameKey, game.GameGUID, game.GameScheduleNum,
            game.StartTimeTBD, game.IsConferenceGame,
          ),
        ),
      );
    }
  }

  return dict;
}
